<template>
  <v-row>
    <v-col cols="12">
      
      <v-card class="card-quote mx-0 px-5" elevation="0">
        <transition>
          <v-row v-if="!verifyExistsCarrierReferenceWithPlanSelected">
            <v-col cols="12">
              <v-alert class="mx-2 mt-6" outlined type="info">
                Por favor, selecione a operadora de referência e o(s) plano(s) desejado(s). Operadora de Referência é a primeira opção de venda.
              </v-alert>
            </v-col>
          </v-row>
        </transition>

        <v-row v-for="(benefit, indexBenefit) in benefits" :key="indexBenefit" justify="center" align="center">
          <v-col cols="auto" style="width: 5% !important;">
            <!-- <v-img :src="$util.getImgByBenefitCode(benefit.code)" max-width="100" :max-height="$util.getImgHeightByBenefitCode(benefit.code)" contain></v-img> -->
            <div
              class="d-flex flex-row align-center"
              style="transform: rotate(-90deg);"
              v-if="$util.getImgByBenefitCode(benefit.code)">
              <v-sheet
                icon
                color="title-icon"
                class="d-flex justify-center align-center rounded-circle"
                height="38"
                min-height="38"
                width="38"
                min-width="38">
                <v-icon color="title-icon-background" size="20">{{$util.getImgByBenefitCode(benefit.code).icon}}</v-icon>
              </v-sheet>
              <span
                class="title-foreground--text font-weight-medium ml-2">
                {{$util.getImgByBenefitCode(benefit.code).description}}
              </span>
            </div>
          </v-col>

          <v-col cols="auto" style="width: 95% !important;" class="pl-0">
            <v-slide-group show-arrows>
              <v-slide-item v-for="(carrier, indexCarrier) in benefit.carriers" :key="indexCarrier">
                <v-card elevation="0" width="300" min-height="300" class="pb-5">
                  <v-card-title class="dashed-bottom subheading d-flex justify-center">
                    <v-row v-if="carrier.image" style="width: 100% !important;">
                      <v-col cols="12" class="d-flex justify-center">
                        <v-img class="mr-5" :src="`data:application/octet-stream;base64,${carrier.image}`" max-width="200" height="100" contain></v-img>
                      </v-col>
                    </v-row>
                    <v-row v-else style="height: 124px !important; width: 100% !important;">
                      <v-col cols="12" align-self="center" class="text-center">
                        <p class="mb-0 pb-0 font-weight-bold" style="color: var(--v-quote-base)">
                          {{carrier.comercialName ? carrier.comercialName : (carrier.name ? carrier.name : '-')}}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="my-0" justify="center" align="center" style="width: 100% !important;">
                      <v-col class="py-0 d-flex justify-center align-content-center" cols="12" style="height: 20px !important;">
                        <v-switch
                          :readonly="iReadOnly"
                          class="py-0 my-0 switch-base"
                          dense
                          v-model="carrier.isReference"
                          @change="changeCarrierReference(indexBenefit, indexCarrier, carrier.isReference)"
                          style="height: 20px !important;">
                          <template v-slot:label>
                            <span>Referência</span>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="pl-2" v-bind="attrs" v-on="on">fas fa-info-circle</v-icon>
                              </template>
                              <span>Operadora de Referência é a primeira opção de venda</span>
                            </v-tooltip>
                          </template>
                        </v-switch>
                      </v-col>
                    </v-row>
                  </v-card-title>

                  <v-row justify="center" align="center" class="py-2">
                    <v-col align-self="start">
                      <v-list dense v-for="(planClassifications, indexPlanClassification) in carrier.planClassifications" :key="indexPlanClassification">
                        <v-alert class="mx-1 my-0 font-weight-bold text-h6 foreground--text" dense color="transparent">
                          {{ planClassifications.name && planClassifications.name.trim().length ? planClassifications.name : '-' }}
                        </v-alert>
                        
                        <v-list-item 
                          style="height: 35px !important; word-break: break-word !important;"
                          :style="plan.name && plan.name.length > 25 ? {marginBottom: '10px !important', marginTop: '5px !important'} : {}"
                          class="pa-1 ma-0" 
                          v-for="(plan, indexPlan) in planClassifications.plans" :key="indexPlan">
                          <v-list-item-content class="d-flex pa-0 ma-0">
                            <v-checkbox
                              :readonly="iReadOnly"
                              class="px-3 py-0" 
                              :disabled="plan.disabled" 
                              v-model="plan.selected" 
                              @change="verifyLimitItemsSelecteds(indexBenefit, indexCarrier, indexPlanClassification, indexPlan, plan.selected)">
                              <template v-slot:label>
                                <span v-if="!plan.detail" style="font-size: 20px !important;">
                                  {{plan.name ? (plan.name.length > 40 ? `${plan.name.substring(0, 40)}...` : plan.name) : '-' }}
                                </span>
                                
                                <v-tooltip v-else right color="foreground">
                                  <template v-slot:activator="{ on, attrs }">
                                    <span style="font-size: 20px !important;" v-on="on" v-bind="attrs">
                                      {{plan.name ? (plan.name.length > 40 ? `${plan.name.substring(0, 40)}...` : plan.name) : '-' }}
                                    </span>
                                  </template>
                                  <span class="caption icon-color pl-1" style="font-weight: bold">
                                    {{ plan.fullDescription ? plan.fullDescription : ( plan.description ? plan.description : '')}}
                                  </span>
                                </v-tooltip>
                              </template>
                            </v-checkbox>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <v-alert class="mx-2 info--text" outlined type="info" v-if="carrier.maxSelecteds" dismissible dense>
                        Limite máximo por operadora: 05 planos.
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-col>
        </v-row>
      </v-card>
      
      <v-card class="card-quote mx-0 mt-6 px-5 pb-16 pt-5" elevation="0" v-if="selectedJuridicalPerson === 'PJ_PLAN' && plansGroupByBenefitCarrier.length">
        <v-row>
          <v-col cols="12">
            <v-alert class="mx-2 mt-6 info--text" outlined type="info" v-if="isOverHolderDistribuition || isOverDependentDistribuition || !verifySomeLifeInserted">
              Por favor, distribua corretamente o número de vidas por faixa etária.
            </v-alert>
          </v-col>
        </v-row>
        
        <v-row v-for="(benefitCarrier, indexBenefitCarrier) in plansGroupByBenefitCarrier" :key="indexBenefitCarrier" justify="center" align="center">
          <v-col cols="auto" style="width: 5% !important;">
            <!-- <v-img :src="$util.getImgByBenefitCode(benefitCarrier.benefitCode)" max-width="100" :height="$util.getImgHeightByBenefitCode(benefitCarrier.benefitCode)" contain></v-img> -->
            <div
              class="d-flex flex-row align-center"
              style="transform: rotate(-90deg);"
              v-if="$util.getImgByBenefitCode(benefitCarrier.benefitCode)">
              <v-sheet
                icon
                color="title-icon"
                class="d-flex justify-center align-center rounded-circle"
                height="38"
                min-height="38"
                width="38"
                min-width="38">
                <v-icon color="title-icon-background" size="20">{{$util.getImgByBenefitCode(benefitCarrier.benefitCode).icon}}</v-icon>
              </v-sheet>
              <span
                class="title-foreground--text font-weight-medium ml-2">
                {{$util.getImgByBenefitCode(benefitCarrier.benefitCode).description}}
              </span>
            </div>
          </v-col>
          
          <v-col cols="auto" style="width: 95% !important;" class="pl-0">
            <v-row>
              <v-col cols="12" class="dashed-bottom">
                <v-img v-if="benefitCarrier.carrierImage" :src="`data:application/octet-stream;base64,${benefitCarrier.carrierImage}`" max-width="200" height="100" contain></v-img>
                <v-row v-else style="height: 100px !important;" class="mt-0">
                  <v-col cols="12" align-self="center">
                    <p class="mb-0 pb-0 font-weight-bold" style="color: var(--v-quote-base)">
                      {{benefitCarrier.carrierComercialName ? benefitCarrier.carrierComercialName : (benefitCarrier.carrierName ? benefitCarrier.carrierName : '-')}}
                    </p>
                  </v-col>
                </v-row>
              </v-col>
              
              <v-col cols="12">
                <v-slide-group show-arrows>
                  <v-slide-item class="dashed-right" v-for="(plan, indexPlan) in benefitCarrier.plans" :key="indexPlan">
                   <v-card elevation="0" width="350" min-height="300" class="pb-5 pr-5">
                     <v-card-title class="subheading d-flex justify-center" style="color: var(--v-foreground-base); font-weight: bold;">
                       {{ plan.name }}
                     </v-card-title>
                     
                     <v-card-text>
                       <v-row class="pt-5">
                         <v-col cols="3" class="component-col-header text-center"></v-col>
                         <v-col cols="3" class="component-col-header py-0 my-0 text-center">
                           <p class="pb-0 mb-0" style="font-size: 14px; line-height: 5px;">T</p>
                           <p class="py-0 my-0 text-truncate" style="font-size: 10px;">Titulares</p>
                         </v-col>
                         <v-col cols="3" class="component-col-header pl-0 ml-0 pr-0 mr-0 py-0 my-0 text-center">
                           <p class="pb-0 mb-0" style="font-size: 14px; line-height: 5px;">D</p>
                           <p class="py-0 my-0 text-truncate" style="font-size: 10px;">Dependentes</p>
                         </v-col>
                         <v-col cols="3" class="component-col-header pl-0 ml-0 pr-0 mr-0 py-0 my-0 text-center">
                           <p class="pb-0 mb-0" style="font-size: 14px; line-height: 5px;">TOTAL</p>
                           <p class="py-0 my-0" style="font-size: 10px;"> </p>
                         </v-col>

                         <v-col cols="12">
                           <v-row v-for="(ageInterval, indexAgeInterval) in plan.ageIntervals" :key="indexAgeInterval">
                             <v-col cols="3" class="component-col-age text-right">
                               {{ ageInterval.description }}
                             </v-col>
                             <v-col cols="3" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
                               <v-text-field
                                 :readonly="iReadOnly"
                                 @input="managerAgeIntervalItem(indexBenefitCarrier);"
                                 @keydown="$util.acceptOnlyNumbers"
                                 v-model.number="ageInterval.holderCount"
                                 :maxlength="6"
                                 outlined 
                                 dense>
                               </v-text-field>
                             </v-col>
                             <v-col cols="3" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
                               <v-text-field
                                 :readonly="iReadOnly"
                                 @input="managerAgeIntervalItem(indexBenefitCarrier)"
                                 @keydown="$util.acceptOnlyNumbers"
                                 v-model.number="ageInterval.dependentCount"
                                 :maxlength="6"
                                 outlined 
                                 dense>
                               </v-text-field>
                             </v-col>
                             <v-col cols="3" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
                               <v-text-field
                                 :readonly="iReadOnly"
                                 v-model.number="ageInterval.total"
                                 :maxlength="6"
                                 disabled
                                 outlined
                                 filled
                                 dense>
                               </v-text-field>
                             </v-col>
                           </v-row>
                         </v-col>

                         <v-col cols="3" class="component-col text-right">
                           Total
                         </v-col>
                         <v-col cols="3" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
                           <v-text-field
                             :readonly="iReadOnly"
                             v-model="plan.ageIntervalsTotal.sumHolderCount"
                             disabled
                             type="number"
                             outlined
                             filled
                             dense
                           />
                         </v-col>
                         <v-col cols="3" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
                           <v-text-field
                             :readonly="iReadOnly"
                             v-model="plan.ageIntervalsTotal.sumDependentCount"
                             disabled
                             type="number"
                             outlined
                             filled
                             dense
                           />
                         </v-col>
                         <v-col cols="3" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
                           <v-text-field
                             :readonly="iReadOnly"
                             v-model="plan.ageIntervalsTotal.sumTotal"
                             disabled
                             outlined
                             filled
                             dense
                           />
                         </v-col>
                       </v-row>
                     </v-card-text>
                    </v-card>
                  </v-slide-item>
                  
                  <v-slide-item>
                    <v-card elevation="0" width="130" min-height="300" class="pb-5 pr-5 pl-5">
                      <v-card-title class="subheading d-flex justify-center" style="color: var(--v-foreground-base); font-weight: bold;">
                        &nbsp;
                      </v-card-title>
                      
                      <v-card-text>
                        <v-row class="pt-5">
                          <v-col cols="12" class="component-col-header pl-0 ml-0 pr-0 mr-0 py-0 my-0 text-center">
                            <p class="pb-0 mb-0" style="font-size: 14px; line-height: 5px;">TOTAL</p>
                            <p class="py-0 my-0" style="font-size: 10px;"> </p>
                          </v-col>
                          <v-col cols="12">
                            <v-row v-for="(ageIntervalSum, indexAgeIntervalSum) in benefitCarrier.sumTotals.ageIntervalsSum" :key="indexAgeIntervalSum">
                              <v-col cols="12" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
                                <v-text-field
                                  :readonly="iReadOnly"
                                  v-model="ageIntervalSum.sum"
                                  disabled
                                  outlined
                                  filled
                                  dense>
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" class="component-col-age pl-1 pr-0 mr-0 py-0 my-0">
                                <v-text-field
                                  :readonly="iReadOnly"
                                  v-model="benefitCarrier.sumTotals.total"
                                  disabled
                                  outlined
                                  filled
                                  dense>
                                </v-text-field>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>

      <ConfirmDialog
        :textDialog="'Você deseja realmente iniciar uma nova cotação?'"
        :showDialog="showDialogConfirmation"
        @onClickCancelDialog="onClickCancelDialog"
        @onClickConfirmDialog="onClickConfirmDialog">
      </ConfirmDialog>
    </v-col>

    <v-dialog
      v-model="showDialogLifes"
      persistent
      scrollable
      max-width="600">
      <v-card>
        <v-card-subtitle style="color: var(--v-primary-base); box-shadow: 1px 1px 5px 3px color-mix(in srgb, var(--v-shadow-base) 50%, transparent);">
          <v-row class="mt-2">
            <v-col cols="12" class="text-center">
              <span v-if="msgDialogType === 'INFORMATION'">Informe a idade dos usuários com 59 anos ou mais.</span>
              <v-alert v-else-if="msgDialogType === 'EMPTY'" dense outlined type="error">
                Por favor, preencha todos os campos.
              </v-alert>
              <v-alert v-else-if="msgDialogType === 'AGE'" dense outlined type="error">
                A idade deve ser maior ou igual a 59 anos.
              </v-alert>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-text class="pt-5" style="min-height: 100px !important; max-height: 650px !important;">
          <v-row class="py-0 my-0" v-for="(benefitCarrier, indexBenefitCarrier) in getBenefitCarrierWithAgesFiftyNinePlus" :key="indexBenefitCarrier">
            <v-col
              :class="{'dashed-bottom': benefitCarrier.plans.length > 1 && indexPlan < benefitCarrier.plans.length - 1}"
              cols="12" v-for="(plan, indexPlan) in benefitCarrier.plans" :key="indexPlan">
              <v-row>
                <v-col cols="12">
                  <p class="pb-0 mb-0 font-weight-bold text-center">{{ plan.name ? plan.name : '-' }}</p>
                  <p class="caption text-center">
                    {{
                      `${benefitCarrier.benefitName ? benefitCarrier.benefitName : ''} - 
                       ${benefitCarrier.carrierName ? benefitCarrier.carrierName : ''}`
                    }}
                  </p>
                </v-col>
              </v-row>
              
              <v-row class="py-0 my-0" v-for="(item, index) in plan.enumeratedAges" :key="index">
                <v-col cols="4" md="5" class="component-col-age text-truncate text-right py-0 my-0 pt-md-2">
                  {{ item.description }}
                </v-col>
                <v-col cols="4" md="2" class="component-col-age pr-md-0 mr-md-0 py-0 my-0">
                  <v-text-field
                    @keydown="$util.acceptOnlyNumbers"
                    :maxlength="3"
                    v-model.number="item.age"
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="4" md="5" class="component-col-header text-center py-0 my-0"></v-col>
              </v-row>
              
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn
            class="btn-quote"
            large
            width="130"
            @click="cancelDialog()">
            <v-icon left>fas fa-times</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            class="btn-quote"
            large
            width="130"
            @click="confirmDialog()">
            <v-icon left>fas fa-check</v-icon>
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-col cols="12">
      <v-card>
        <v-card-actions class="d-block d-sm-block d-md-block d-lg-block text-right px-0 pb-3">
          <v-spacer></v-spacer>
          <v-btn
            :disabled="iReadOnly"
            @click="() => $router.back()"
            class="btn-quote mt-1 ml-0 mr-2"
            large
            :width="buttonWidth">
            <v-icon left>fas fa-arrow-left</v-icon>
            Voltar
          </v-btn>
          <v-btn
            :disabled="iReadOnly"
            @click="sendInstitutional()"
            class="btn-quote mt-1 ml-0 mr-2"
            large
            :width="buttonWidth">
            <v-icon left>fas fa-list-ul</v-icon>
            Enviar Institucional
          </v-btn>
          <v-btn
            @click="calculateQuote()"
            :disabled="!verifyExistsCarrierReferenceWithPlanSelected 
            || !verifySomePlanSelected || !verifySomeLifeInserted || iReadOnly"
            class="btn-quote mt-1 ml-0 mr-2"
            large
            :width="buttonWidth">
            <v-icon left>fas fa-calculator</v-icon>
            Calcular
          </v-btn>
          <v-btn
            @click="sendQuote()"
            :disabled="!verifyExistsCarrierReferenceWithPlanSelected 
              || !verifySomePlanSelected || !verifySomeLifeInserted || iReadOnly"
            class="btn-quote mt-1 ml-0 mr-2"
            large
            :width="buttonWidth">
            <v-icon left>fas fa-arrow-right</v-icon>
            Enviar Cotação
          </v-btn>
          <v-btn
            v-if="allowSendKit"
            @click="requestKit()"
            :disabled="!verifyExistsCarrierReferenceWithPlanSelected 
              || !verifySomePlanSelected || !verifySomeLifeInserted || iReadOnly"
            class="btn-quote mt-1 ml-0 mr-2"
            large
            :width="buttonWidth">
            <v-icon left>fas fa-file</v-icon>
            Solicitar Kit
          </v-btn>
          <v-btn
            :disabled="iReadOnly"
            @click="createNewQuote()"
            class="btn-quote mt-1 ml-0 mr-2"
            large
            :width="buttonWidth">
            <v-icon left>fas fa-redo</v-icon>
            Nova Cotação
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import ConfirmDialog from "@/components/quote-form/confirmationDialog.vue";
import QuoteService from "@/services/odoo/QuoteService";
import AuthService from "@/services/AuthService";

export default {
  name: 'plansSlider',
  components: {
    ConfirmDialog,
  },
  data: () => ({
    allowSendKit: false,
    iReadOnly: false,
    benefitWithCarrierSelecteds: [],
    msgDialogType: 'INFORMATION',
    actionButton: null,
    showDialogLifes: false,
    isOverHolderDistribuition: false,
    isOverDependentDistribuition: false,
    showDialogConfirmation: false,
    buttonWidth: 200,
    benefits: [],
    plansTemp: [],
    plansGroupByBenefitCarrier: [],
    ageIntervals: [
      { description: '0 a 18', holderCount: null, dependentCount: null, total: null },
      { description: '19 a 23', holderCount: null, dependentCount: null, total: null },
      { description: '24 a 28', holderCount: null, dependentCount: null, total: null },
      { description: '29 a 33', holderCount: null, dependentCount: null, total: null },
      { description: '34 a 38', holderCount: null, dependentCount: null, total: null },
      { description: '39 a 43', holderCount: null, dependentCount: null, total: null },
      { description: '44 a 48', holderCount: null, dependentCount: null, total: null },
      { description: '49 a 53', holderCount: null, dependentCount: null, total: null },
      { description: '54 a 58', holderCount: null, dependentCount: null, total: null },
      { description: '59 ou +', holderCount: null, dependentCount: null, total: null },
    ],
    ageIntervalsTotal: {
      sumHolderCount: null,
      sumDependentCount: null,
      sumTotal: null,
    },
    sumTotals: {
      ageIntervalsSum: [
        { description: '0 a 18', sum: null },
        { description: '19 a 23', sum: null },
        { description: '24 a 28', sum: null },
        { description: '29 a 33', sum: null },
        { description: '34 a 38', sum: null },
        { description: '39 a 43', sum: null },
        { description: '44 a 48', sum: null },
        { description: '49 a 53', sum: null },
        { description: '54 a 58', sum: null },
        { description: '59 ou +', sum: null },
      ],
      total: null,
    },
  }),
  props: {
    benefitsLoaded: {
      type: Array,
    },
    selectedJuridicalPerson: {
      type: String,
      required: true,
    }
  },
  computed: {
    ...mapGetters(['benefitsObj', 'ageIntervalsTotalObj', 'quoteDataObj']),
    verifyExistsCarrierReferenceWithPlanSelected() {
      let allReferenceCarrierWithPlan = false;

      const benefitsToVerify = JSON.parse(JSON.stringify(this.benefits));
      const referenceCarriers = [];
      
      benefitsToVerify.map(benefit => {
        const carrierFound = benefit.carriers.find(carrier => carrier.isReference);
        if(carrierFound) {
          referenceCarriers.push(carrierFound);
        }
      });
      
      if(referenceCarriers.length) {
        allReferenceCarrierWithPlan = referenceCarriers.map(carrier => {
          return carrier.planClassifications.map(planClassification => {
              return planClassification.plans.some(plan => plan.selected);
          }).some(element => element);
        }).every(item => item)
        
      }

      const hasPlansSelectedWithoutReferenceCarrier = benefitsToVerify.map(benefit => {
        return !benefit.carriers.some(carrier => carrier.isReference) && benefit.carriers.map(carrier => {
          return !carrier.isReference && carrier.planClassifications.map(planClassification => {
            return planClassification.plans.some(plan => plan.selected);
          }).some(element => element);
        }).some(carrier => carrier);
      }).some(benefit => benefit);
      
      
      return allReferenceCarrierWithPlan && !hasPlansSelectedWithoutReferenceCarrier;
    },
    verifySomePlanSelected() {
      if(this.selectedJuridicalPerson === 'PJ_PLAN') {
        return this.plansGroupByBenefitCarrier.length;
      } else {
        let sumSelecteds = 0;
        
        this.benefits.forEach(benefit => {
          benefit.carriers.forEach(carrier => {
            carrier.planClassifications.forEach(planClassification => {
              planClassification.plans.forEach(plan =>  {
               if(plan.selected){
                 sumSelecteds++;
               }
              })
            })
          })
        })
        
        return sumSelecteds > 0;
      }
    },
    verifySomeLifeInserted() {
      if(this.selectedJuridicalPerson === 'PJ_PLAN') {
        const allSumLifes = [];
        this.plansGroupByBenefitCarrier.forEach(benefitCarrier => {
          let sumLifes = 0;
          if(benefitCarrier && benefitCarrier.sumTotals && benefitCarrier.sumTotals.total) {
            sumLifes = sumLifes + benefitCarrier.sumTotals.total;
          }
          allSumLifes.push(sumLifes);
        })
        
        return allSumLifes.every(sum => sum > 0);
      }
      return true;
    },
    getBenefitCarrierWithAgesFiftyNinePlus() {
      if(this.plansGroupByBenefitCarrier && this.plansGroupByBenefitCarrier.length) {
        this.plansGroupByBenefitCarrier.forEach(benefitCarrier => {
          benefitCarrier.plans.forEach(plan => {
            
            let enumeratedAges = [];
            if(plan && plan.ageIntervals && plan.ageIntervals[plan.ageIntervals.length -1]
              && plan.ageIntervals[plan.ageIntervals.length -1].total) {
              
              const holderCount = plan.ageIntervals[plan.ageIntervals.length - 1].holderCount;
              if(holderCount && parseInt(holderCount) > 0) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                enumeratedAges = Array.from({length: holderCount}, (v, i) => ({
                  description: `Titular ${i+1}`,
                  age: null,
                }));
              }

              const dependentCount = plan.ageIntervals[plan.ageIntervals.length - 1].dependentCount;
              if(dependentCount && parseInt(dependentCount) > 0) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                enumeratedAges = enumeratedAges.concat(Array.from({length: dependentCount}, (v, i) => ({
                  description: `Dependente ${i+1}`,
                  age: null,
                })));
              }
            }

            if(enumeratedAges && enumeratedAges.length) {
              plan.enumeratedAges = JSON.parse(JSON.stringify(enumeratedAges));
            }
          })
        })
      }
      
      return this.plansGroupByBenefitCarrier.map(benefitCarrier => {
        const plans = benefitCarrier.plans.filter(plan => plan.ageIntervals[plan.ageIntervals.length -1].total);
        if(plans && plans.length) {
          return {
            ...benefitCarrier,
            plans: plans,
          }
        } else {
          return null
        }
      }).filter(item => item);
    }
  },
  methods: {
    ...mapMutations(['showmsg', 'setDialogLoading']),
    ...mapActions(['setBenefitsObj', 'setPlansGroupByBenefitCarrierObj', 'setQuoteId']),
    managerAgeIntervalItem(indexBenefitCarrier) {
      this.plansGroupByBenefitCarrier[indexBenefitCarrier].plans.forEach(plan => {
        plan.ageIntervalsTotal.sumTotal = 0;
        plan.ageIntervalsTotal.sumDependentCount = 0;
        plan.ageIntervalsTotal.sumHolderCount = 0;
        
        plan.ageIntervals.forEach((ageInterval, indexAgeInterval) => {
          const holderCount = ageInterval.holderCount && parseInt(ageInterval.holderCount) > 0 ? parseInt(ageInterval.holderCount): 0;
          const dependentCount = ageInterval.dependentCount && parseInt(ageInterval.dependentCount) > 0 ? parseInt(ageInterval.dependentCount) : 0;
          ageInterval.total = ((holderCount + dependentCount) > 0) ? holderCount + dependentCount : null;

          if(ageInterval.total && parseInt(ageInterval.total) > 0) {
            plan.ageIntervalsTotal.sumTotal = plan.ageIntervalsTotal.sumTotal + parseInt(ageInterval.total);
          }

          if(ageInterval.dependentCount && parseInt(ageInterval.dependentCount) > 0) {
            plan.ageIntervalsTotal.sumDependentCount = plan.ageIntervalsTotal.sumDependentCount + parseInt(ageInterval.dependentCount);
          }

          if(ageInterval.holderCount && parseInt(ageInterval.holderCount) > 0) {
            plan.ageIntervalsTotal.sumHolderCount = plan.ageIntervalsTotal.sumHolderCount + parseInt(ageInterval.holderCount);
          }
        })

        if(plan.ageIntervalsTotal.sumTotal === 0) {
          plan.ageIntervalsTotal.sumTotal = null;
        }

        if(plan.ageIntervalsTotal.sumDependentCount === 0) {
          plan.ageIntervalsTotal.sumDependentCount = null;
        }

        if(plan.ageIntervalsTotal.sumHolderCount === 0) {
          plan.ageIntervalsTotal.sumHolderCount = null;
        }
      })

      this.sumAgeIntervalsItemsByBenefitCarrier(indexBenefitCarrier);
      //this.verifyMaxLifesByHolder();
      //this.verifyMaxLifesByDependent();

      //savePlansTemp
      if(this.plansGroupByBenefitCarrier) {
        this.plansGroupByBenefitCarrier.forEach(benefitCarrier => {
          if(benefitCarrier && benefitCarrier.plans && benefitCarrier.plans.length) {
            benefitCarrier.plans.forEach(plan => {
              const planFound = this.plansTemp.find(planTemp => planTemp.id === plan.id);
              if(planFound && JSON.parse(JSON.stringify(planFound)) !== JSON.parse(JSON.stringify(plan))) {
                const indexOfPlan = this.plansTemp.indexOf(planFound);
                this.plansTemp[indexOfPlan] = JSON.parse(JSON.stringify(plan));
              }
            })
          }
        })
      }
      
      this.setPlansGroupByBenefitCarrierObj(JSON.parse(JSON.stringify(this.plansGroupByBenefitCarrier)))
    },
    clearAndUpdateSumAgeIntervalsByBenefitCarriers() {
      if(this.selectedJuridicalPerson === 'PJ_PLAN') {
        this.plansGroupByBenefitCarrier.forEach(benefitCarrier => {
          benefitCarrier.sumTotals.ageIntervalsSum.forEach(item => {
            item.sum = null;
          });
        });

        this.updateAllAgeIntervals();
      }
    },
    updateAllAgeIntervals() {
      setTimeout(() => {
        this.plansGroupByBenefitCarrier.forEach((benefitCarrier, indexBenefitCarrier) => {
          this.managerAgeIntervalItem(indexBenefitCarrier);
        });
      }, 100);
    },
    sumAgeIntervalsItemsByBenefitCarrier(indexBenefitCarrier) {
      this.plansGroupByBenefitCarrier[indexBenefitCarrier].sumTotals.ageIntervalsSum.forEach(item => {
        item.sum = null;
      });

      this.plansGroupByBenefitCarrier[indexBenefitCarrier].plans.forEach(plan => {
        plan.ageIntervals.forEach((ageInterval, indexAgeInterval) => {
          if(ageInterval.total) {
            this.plansGroupByBenefitCarrier[indexBenefitCarrier].sumTotals.ageIntervalsSum[indexAgeInterval].sum =
              this.plansGroupByBenefitCarrier[indexBenefitCarrier].sumTotals.ageIntervalsSum[indexAgeInterval].sum + ageInterval.total;
          }
        });
      });

      let sumTotal = 0;
      this.plansGroupByBenefitCarrier[indexBenefitCarrier].sumTotals.ageIntervalsSum.forEach(item => {
        if(item.sum) {
          sumTotal = sumTotal + item.sum
        }
      });

      if(sumTotal && sumTotal > 0) {
        this.plansGroupByBenefitCarrier[indexBenefitCarrier].sumTotals.total = sumTotal;
      } else {
        this.plansGroupByBenefitCarrier[indexBenefitCarrier].sumTotals.total = null;
      }
      
    },
    verifyMaxLifesByHolder() {
     const allTotalToHolder = [];
      this.plansGroupByBenefitCarrier.forEach(benefitCarrier => {
        let totalSumHolder = 0;
        benefitCarrier.plans.forEach(plan => {
          plan.ageIntervals.forEach(ageInterval => {
            if (ageInterval && ageInterval.holderCount) {
              totalSumHolder = totalSumHolder + ageInterval.holderCount
            }
          });
        });
        allTotalToHolder.push(totalSumHolder);
      });

      const totalSumHolderFound = allTotalToHolder.find(totalSumHolder => totalSumHolder && totalSumHolder != this.ageIntervalsTotalObj.sumHolderCount)
      if(totalSumHolderFound) {
        this.showmsg({text: 'A quantidade de titulares distribuída nos planos é maior que a quantidade de titulares informada acima. ' +
            'Por favor, distribua corretamente as vidas nos planos.<br/><br/>' +
            `Titulares informados: ${this.ageIntervalsTotalObj && this.ageIntervalsTotalObj.sumHolderCount ? this.ageIntervalsTotalObj.sumHolderCount: '0'} <br/>` + 
            `Titulares distribuídos: ${totalSumHolderFound}`, type: 'warning'});
        this.isOverHolderDistribuition = true;
        
      } else {
        this.isOverHolderDistribuition = false;
      }
    },
    verifyMaxLifesByDependent() {
      const allTotalToDependent = [];
      
      this.plansGroupByBenefitCarrier.forEach(benefitCarrier => {
        let totalSumDependent = 0;
        benefitCarrier.plans.forEach(plan => {
          plan.ageIntervals.forEach(ageInterval => {
            if (ageInterval && ageInterval.dependentCount) {
              totalSumDependent = totalSumDependent + ageInterval.dependentCount
            }
          });
        });
        allTotalToDependent.push(totalSumDependent);
      });

      const totalSumDependentFound = allTotalToDependent.find(totalSumDependent => totalSumDependent && totalSumDependent != this.ageIntervalsTotalObj.sumDependentCount)
      if(totalSumDependentFound) {
        this.showmsg({text: 'A quantidade de titulares distribuída nos planos é maior que a quantidade de titulares informada acima. ' +
            'Por favor, distribua corretamente as vidas nos planos.<br/><br/>' +
            `Dependentes informados: ${this.ageIntervalsTotalObj && this.ageIntervalsTotalObj.sumDependentCount ? this.ageIntervalsTotalObj.sumDependentCount : '0'} <br/>` +
            `Dependentes distribuídos: ${totalSumDependentFound}`, type: 'warning'});
        this.isOverDependentDistribuition = true;

      } else {
        this.isOverDependentDistribuition = false;
      }
    },
    createSelectedAndDisabledAttributesToBenefits() {
      if(this.benefits && this.benefits.length) {
        this.benefits.forEach(benefit => {
          
          if(benefit.carriers && benefit.carriers.length) {
            benefit.carriers.forEach(carrier => {
              if(!carrier.isReference) {
                carrier.isReference = false;
              }
              
              if(carrier.planClassifications && carrier.planClassifications.length) {
                carrier.planClassifications.forEach(planClassification => {
                  
                  if(planClassification.plans && planClassification.plans.length) {
                    planClassification.plans.forEach(plan => {
                      plan.selected = false;
                      plan.disabled = false;
                    });
                  }
                })
              }
            });
          }
        });
      }
      this.updateBenefitsObj();
    },
    verifyLimiteItemsSelectedsByLimitCarrier(indexBenefit, indexCarrier, indexPlanClassification, indexPlan, statusSelected) {
      if(statusSelected) {
        const benefitFound = this.benefitWithCarrierSelecteds.find(item => item.indexBenefit === indexBenefit);
        if(benefitFound) {
          const indexOfBenefit = this.benefitWithCarrierSelecteds.indexOf(benefitFound);
          const carrierFound = this.benefitWithCarrierSelecteds[indexOfBenefit].carriers.find(item => item.index === indexCarrier);

          if(carrierFound) {
            const indexOfCarrier =  this.benefitWithCarrierSelecteds[indexOfBenefit].carriers.indexOf(carrierFound);
            this.benefitWithCarrierSelecteds[indexOfBenefit].carriers[indexOfCarrier].countPlans++;

          } else {
            this.benefitWithCarrierSelecteds[indexOfBenefit].carriers.push({index: indexCarrier, countPlans: 1});
          }

        } else {
          this.benefitWithCarrierSelecteds.push({
            indexBenefit,
            carriers: [{index: indexCarrier, countPlans: 1}]
          })
        }

        //disabled plans by carriers count max 5
        this.benefitWithCarrierSelecteds.forEach(benefit => {
          if(benefit.indexBenefit === indexBenefit && benefit.carriers &&
            benefit.carriers.length  && benefit.carriers.length === 5) {

            this.benefits[indexBenefit].carriers.forEach((carrier, iCarrier) => {
              if(!benefit.carriers.some(item => item.index === iCarrier)) {
                carrier.planClassifications.forEach(planClassification => {
                  planClassification.plans.forEach(plan => {
                    if(plan.selected == false) {
                      plan.disabled = true;
                    }
                  });
                });
              }
            });
          }
        });
      } else {
        const benefitCarriersToRemove = [];
        this.benefitWithCarrierSelecteds.forEach((benefit, iBenefit) => {
          benefit.carriers.forEach((carrier, iCarrier) => {
            if(carrier.index === indexCarrier && carrier.countPlans === 1) {
              benefitCarriersToRemove.push({ indexBenefit: iBenefit, indexCarrier: iCarrier});
            } else if(carrier.index === indexCarrier) {
              carrier.countPlans--;
            }
          })
        })

        if(benefitCarriersToRemove.length) {
          benefitCarriersToRemove.forEach((item) => {
            this.benefitWithCarrierSelecteds[item.indexBenefit].carriers.splice(item.indexCarrier, 1);
          });

          this.benefits[indexBenefit].carriers.forEach((carrier) => {
            carrier.planClassifications.forEach(planClassification => {
              if(carrier.planClassifications.flatMap(planClassification => planClassification.plans).filter(planItem => planItem.selected).length < 5) {
                planClassification.plans.forEach(plan => {
                  plan.disabled = false;
                });
              }
            });
          });
        }

        this.benefitWithCarrierSelecteds = Object.assign([], this.benefitWithCarrierSelecteds.filter(item => item.carriers && item.carriers.length));
      }
    },
    verifyLimitItemsSelectedsByLimitPlan(indexBenefit, indexCarrier, indexPlanClassification, indexPlan, statusSelected) {
      let itemsSelecteds = [];
      itemsSelecteds = itemsSelecteds.concat(...this.benefits[indexBenefit].carriers[indexCarrier].planClassifications
        .map(planClassification => planClassification.plans.map(plan =>  ({selected: plan.selected}))))

      if(statusSelected && itemsSelecteds.filter(item => item.selected).length === 5) {
        this.benefits[indexBenefit].carriers[indexCarrier].planClassifications.forEach(planClassification => {
          planClassification.plans.forEach(plan => {
            if(plan.selected == false) {
              plan.disabled = true;
            }
          });
        });
        this.benefits[indexBenefit].carriers[indexCarrier].maxSelecteds = true;
        
      } else {
        this.benefits[indexBenefit].carriers[indexCarrier].maxSelecteds = false;
        this.benefits[indexBenefit].carriers[indexCarrier].planClassifications.forEach(planClassification => {
          planClassification.plans.forEach(plan => {
            plan.disabled = false;
          });
        });

        if(!statusSelected) {
          this.clearAndUpdateSumAgeIntervalsByBenefitCarriers();
        }
      }
      this.addPlanSelected(this.benefits[indexBenefit],  this.benefits[indexBenefit].carriers[indexCarrier],
        this.benefits[indexBenefit].carriers[indexCarrier].planClassifications[indexPlanClassification].plans[indexPlan]);
      this.updateBenefitsObj();
    },
    verifyLimitItemsSelecteds(indexBenefit, indexCarrier, indexPlanClassification, indexPlan, statusSelected) {
      this.verifyLimiteItemsSelectedsByLimitCarrier(indexBenefit, indexCarrier, indexPlanClassification, indexPlan, statusSelected);
      this.verifyLimitItemsSelectedsByLimitPlan(indexBenefit, indexCarrier, indexPlanClassification, indexPlan, statusSelected);
    },
    changeCarrierReference(indexBenefit, indexCarrier, statusSelected) {
      setTimeout(() => {
        this.benefits[indexBenefit].carriers.forEach(carrier => {
          carrier.isReference = false;
        });

        if(statusSelected) {
          this.benefits[indexBenefit].carriers[indexCarrier].isReference = true;
        }
        
        this.setBenefitsObj(JSON.parse(JSON.stringify(this.benefits)));
      }, 100)
    },
    updateBenefitsObj() {
      const benefitUpdated = JSON.parse(JSON.stringify(this.benefits));
      this.benefits = benefitUpdated;
      this.benefits.sort((a, b) => a.id - b.id);
      this.setBenefitsObj(JSON.parse(JSON.stringify(this.benefits)));
    },
    createNewQuote() {
      this.showDialogConfirmation = !this.showDialogConfirmation;
    },
    onClickCancelDialog() {
      this.showDialogConfirmation = !this.showDialogConfirmation;
    },
    onClickConfirmDialog() {
      this.showDialogConfirmation = !this.showDialogConfirmation;
      this.$emit('hidePlansSlider');
    },
    addPlanSelected(benefitItem, carrierItem, planItem) {
      if(this.selectedJuridicalPerson === 'PJ_PLAN' && benefitItem && carrierItem && planItem) {

        //savePlansTemp
        let planExistsToUpdate = null;
        if(planItem && this.plansTemp.length) {
          planExistsToUpdate = this.plansTemp.find(planTemp => planTemp.id === planItem.id);
          if(planExistsToUpdate) {
            planExistsToUpdate = JSON.parse(JSON.stringify(planExistsToUpdate));
          }
        }

        const benefitCarrier = {
          benefitId: benefitItem.id,
          benefitName: benefitItem.name,
          benefitCode: benefitItem.code,
          carrierId: carrierItem.id,
          carrierName: carrierItem.name,
          carrierComercialName: carrierItem.comercialName,
          carrierImage: carrierItem.image,
          carrierIsReference: carrierItem.isReference,
          plans: [],
          sumTotals: JSON.parse(JSON.stringify(this.sumTotals)),
        }

        const plan = {
          id: planItem.id,
          name: planItem.name,
          ageIntervals: JSON.parse(JSON.stringify(this.ageIntervals)),
          ageIntervalsTotal: JSON.parse(JSON.stringify(this.ageIntervalsTotal)),
        };

        const benefitCarrierFound = this.plansGroupByBenefitCarrier.find(benefitCarrier =>
          benefitCarrier.benefitId === benefitItem.id && benefitCarrier.carrierId === carrierItem.id);
        if(benefitCarrierFound) {
          const indexOfBenefitCarrier = this.plansGroupByBenefitCarrier.indexOf(benefitCarrierFound);
          const planFound = benefitCarrierFound.plans.find(plan => plan.id === planItem.id);

          if(planFound) {
            const indexOfPlan = benefitCarrierFound.plans.indexOf(planFound);
            this.plansGroupByBenefitCarrier[indexOfBenefitCarrier].plans.splice(indexOfPlan, 1);

            if(!this.plansGroupByBenefitCarrier[indexOfBenefitCarrier].plans.length) {
              this.plansGroupByBenefitCarrier.splice(indexOfBenefitCarrier, 1);
            }

          } else {
            this.plansGroupByBenefitCarrier[indexOfBenefitCarrier].plans.push(planExistsToUpdate ? planExistsToUpdate : plan);
            //savePlansTemp
            this.addPlanTemp(plan);
          }
        } else {
          benefitCarrier.plans.push(planExistsToUpdate ? planExistsToUpdate : plan);
          this.plansGroupByBenefitCarrier.push(benefitCarrier);
          //savePlansTemp
          this.addPlanTemp(plan);
        }

        this.plansGroupByBenefitCarrier.sort((a, b) => a.benefitId - b.benefitId);

        //savePlansTemp
        if(planExistsToUpdate) {
          this.updateAllAgeIntervals();
        }
      }
    },
    addPlanTemp(plan) {
      //savePlansTemp
      if(plan && !this.plansTemp.some(planTemp => planTemp.id === plan.id)) {
        this.plansTemp.push(JSON.parse(JSON.stringify(plan)))
      }
    },
    sendQuote() {
      this.verifyMaxLifesByHolder();
      if(this.isOverHolderDistribuition){
        return;
      }
      this.verifyMaxLifesByDependent();
      if(this.isOverDependentDistribuition){
        return;
      }
      
      if(this.getBenefitCarrierWithAgesFiftyNinePlus && this.getBenefitCarrierWithAgesFiftyNinePlus.length) {
        this.actionButton = 'SEND_QUOTE';
        this.showDialogLifes = !this.showDialogLifes;
      } else {
        this.saveAndSendQuote();
      }
    },
    calculateQuote() {
      this.verifyMaxLifesByHolder();
      if(this.isOverHolderDistribuition){
        return;
      }
      this.verifyMaxLifesByDependent();
      if(this.isOverDependentDistribuition){
        return;
      }
      
      if(this.getBenefitCarrierWithAgesFiftyNinePlus && this.getBenefitCarrierWithAgesFiftyNinePlus.length) {
        this.actionButton = 'CALCULATE_QUOTE';
        this.showDialogLifes = !this.showDialogLifes;
      } else {
        this.calculateAndDownloadQuote();
      }
    },
    requestKit() {
      this.verifyMaxLifesByHolder();
      if(this.isOverHolderDistribuition){
        return;
      }
      this.verifyMaxLifesByDependent();
      if(this.isOverDependentDistribuition){
        return;
      }
      
      if(this.getBenefitCarrierWithAgesFiftyNinePlus && this.getBenefitCarrierWithAgesFiftyNinePlus.length) {
        this.actionButton = 'REQUEST_KIT';
        this.showDialogLifes = !this.showDialogLifes;
      } else {
        this.calculateAndSaveSessionStorageDataAndRedirect();
      }
    },
    createQuoteDTO() {
      const type = this.selectedJuridicalPerson;

      let lead = null;
      if(this.quoteDataObj && this.quoteDataObj.juridicalPersonObj) {
        lead = {
          cnpj: this.quoteDataObj.juridicalPersonObj.cnpj ? this.$util.removeMask(this.quoteDataObj.juridicalPersonObj.cnpj) : null,
          commercialName: this.quoteDataObj.juridicalPersonObj.legalName,
          city: {
            id: this.quoteDataObj.juridicalPersonObj.city ? this.quoteDataObj.juridicalPersonObj.city.id : null,
            name: this.quoteDataObj.juridicalPersonObj.city ? this.quoteDataObj.juridicalPersonObj.city.name : null,
            state: {
              id: this.quoteDataObj.juridicalPersonObj.city && this.quoteDataObj.juridicalPersonObj.city.state_id
                ? this.quoteDataObj.juridicalPersonObj.city.state_id.id : null,
              name: this.quoteDataObj.juridicalPersonObj.city && this.quoteDataObj.juridicalPersonObj.city.state_id
                ? this.quoteDataObj.juridicalPersonObj.city.state_id.name : null,
              code: this.quoteDataObj.juridicalPersonObj.city && this.quoteDataObj.juridicalPersonObj.city.state_id
                ? this.quoteDataObj.juridicalPersonObj.city.state_id.code : null,
            }
          },
          contact: {
            name: this.quoteDataObj.juridicalPersonObj.nameContact,
            mobilePhone: this.quoteDataObj.juridicalPersonObj.phoneContact ? this.$util.removeMask(this.quoteDataObj.juridicalPersonObj.phoneContact) : null,
            email: this.quoteDataObj.juridicalPersonObj.emailContact,
            emailCC: this.quoteDataObj.juridicalPersonObj.emailWithCopy,
          }
        }
      }

      let contractFeatures = null;

      if(this.quoteDataObj && this.quoteDataObj.planFiltersObj) {
        contractFeatures = {
          allEmployees: this.quoteDataObj.planFiltersObj.allEmployees && this.quoteDataObj.planFiltersObj.allEmployees.length
            ? this.quoteDataObj.planFiltersObj.allEmployees[0] : null,
          withCopay: this.quoteDataObj.planFiltersObj.allEmployees && this.quoteDataObj.planFiltersObj.hasCopay.length
            ? this.quoteDataObj.planFiltersObj.hasCopay[0] : null,
          classification: this.quoteDataObj.planFiltersObj.planClassifications && this.quoteDataObj.planFiltersObj.planClassifications.length
            ? this.quoteDataObj.planFiltersObj.planClassifications.map(item => {
              return {
                id: parseInt(item),
                name: null
              }
            }) : null,
          accommodation: this.quoteDataObj.planFiltersObj.geographicScopes && this.quoteDataObj.planFiltersObj.accommodations.length
            ? this.quoteDataObj.planFiltersObj.accommodations.map(item => {
              return {
                code: item,
                description: null,
              }
            }) : null,
          geographicScope: this.quoteDataObj.planFiltersObj.geographicScopes && this.quoteDataObj.planFiltersObj.geographicScopes.length
            ? this.quoteDataObj.planFiltersObj.geographicScopes.map(item => {
              return {
                name: item
              }
            }) : null,
          hospitalProviders: this.quoteDataObj.planFiltersObj.hospitalsObj && this.quoteDataObj.planFiltersObj.hospitalsObj.length
            ? this.quoteDataObj.planFiltersObj.hospitalsObj.map(item => {
              return {
                id: item,
                description: null
              }
            }) : null,
          laboratoryProviders: this.quoteDataObj.planFiltersObj.hospitalsObj && this.quoteDataObj.planFiltersObj.laboratoriesObj.length
            ? this.quoteDataObj.planFiltersObj.laboratoriesObj.map(item => {
              return {
                id: item,
                description: null
              }
            }) : null,
        }
      }

      let ageRange = null;
      let benefit = [];
      if(this.selectedJuridicalPerson === 'PJ') {
        if(this.quoteDataObj && this.quoteDataObj.ageIntervalsObj.length) {
          ageRange = JSON.parse(JSON.stringify(this.quoteDataObj.ageIntervalsObj));
          ageRange.forEach((age, indexAge) => {
            if(indexAge < ageRange.length - 1) {
              age.beneficiariesFiftyNinePlus = null
            } else {
              age.beneficiariesFiftyNinePlus = this.quoteDataObj.enumeratedAgesObj
            }
          })
        }

        if (this.quoteDataObj && this.quoteDataObj.benefitsObj) {
          benefit = this.filterBenefitCarrierByPlansSelecteds(this.quoteDataObj.benefitsObj)
          benefit = benefit.map(benefitItem => {
            return {
              id: benefitItem.id,
              code: benefitItem.code,
              name: benefitItem.name,
              carriers: benefitItem.carriers.map(carrierItem => {
                let selectedPlans = [];
                if (carrierItem.planClassifications && carrierItem.planClassifications.length) {
                  carrierItem.planClassifications.forEach(planClassification => {
                    if (planClassification.plans && planClassification.plans.length) {
                      selectedPlans = selectedPlans.concat(planClassification.plans)
                    }
                  })
                }

                if (selectedPlans.length) {
                  selectedPlans = selectedPlans.map(plan => {
                    return {
                      id: plan.id,
                      description: plan.description
                    }
                  })
                }

                return {
                  id: carrierItem.id,
                  comercialName: carrierItem.comercialName,
                  name: carrierItem.name,
                  image: carrierItem.image,
                  isReference: carrierItem.isReference,
                  selectedPlans,
                  planClassifications: carrierItem.planClassifications
                }
              })
            }
          })
        }
      } else if(this.selectedJuridicalPerson === 'PJ_PLAN') {

        if(this.quoteDataObj && this.quoteDataObj.ageIntervalsObj.length) {
          ageRange = this.quoteDataObj.ageIntervalsObj;
        }

        if (this.quoteDataObj && this.quoteDataObj.plansGroupByBenefitCarrierObj) {
          this.quoteDataObj.plansGroupByBenefitCarrierObj.forEach(benefitCarrier => {
            
            const benefitFound = benefit.find(benefit => benefit.id === benefitCarrier.benefitId);

            if(benefitFound) {
              const indexOfBenefit = benefit.indexOf(benefitFound);

              if(indexOfBenefit >= 0) {
                const carrierFound = benefit[indexOfBenefit].carriers.find(carrier => carrier.id === benefitCarrier.carrierId);
                
                if(carrierFound) {
                  const indexOfCarrier = benefit[indexOfBenefit].carriers.indexOf(carrierFound);
                  if(indexOfCarrier >= 0) {
                    benefit[indexOfBenefit].carriers[indexOfCarrier].selectedPlans = benefitCarrier.plans.map(plan => {
                      const ageIntervals = plan.ageIntervals;

                      if(plan.enumeratedAges && plan.enumeratedAges.length) {
                        ageIntervals[ageIntervals.length - 1].beneficiariesFiftyNinePlus = plan.enumeratedAges;
                      }

                      return {
                        id: plan.id,
                        description: plan.description,
                        ageRange: ageIntervals
                      }
                    })
                  }

                } else {
                  let carrierFound = {};
                  let planClassifications = [];
                  const benefitFound = this.benefits.find(benefit => benefit.id === benefitCarrier.benefitId);
                  if(benefitFound) {
                    const indexOfBenefit = this.benefits.indexOf(benefitFound);
                    if(indexOfBenefit >= 0) {
                      carrierFound = this.benefits[indexOfBenefit].carriers.find(carrier => carrier.id === benefitCarrier.carrierId);
                      if(carrierFound) {
                        planClassifications = carrierFound.planClassifications;
                      }
                    }
                  }
                  
                  const carrier = {
                    id: benefitCarrier.carrierId,
                    comercialName: benefitCarrier.carrierComercialName,
                    name: benefitCarrier.carrierName,
                    image: benefitCarrier.carrierImage,
                    isReference: carrierFound.isReference,
                    planClassifications: planClassifications,
                    selectedPlans: benefitCarrier.plans.map(plan => {
                      const ageIntervals = plan.ageIntervals;

                      if(plan.enumeratedAges && plan.enumeratedAges.length) {
                        for(let i = 0; i <= 8; i++) {
                          ageIntervals[i].beneficiariesFiftyNinePlus = null;
                        }
                        ageIntervals[ageIntervals.length - 1].beneficiariesFiftyNinePlus = plan.enumeratedAges;
                      }

                      return {
                        id: plan.id,
                        description: plan.description,
                        ageRange: ageIntervals
                      }
                    })
                  }

                  benefit[indexOfBenefit].carriers.push(carrier);
                }
              }

            } else {
              let carrierFound = {};
              let planClassifications = [];
              const benefitFound = this.benefits.find(benefit => benefit.id === benefitCarrier.benefitId);
              if(benefitFound) {
                const indexOfBenefit = this.benefits.indexOf(benefitFound);
                if(indexOfBenefit >= 0) {
                  carrierFound = this.benefits[indexOfBenefit].carriers.find(carrier => carrier.id === benefitCarrier.carrierId);
                  if(carrierFound) {
                    planClassifications = carrierFound.planClassifications;
                  }
                }
              }
              
              const carrier = {
                id: benefitCarrier.carrierId,
                comercialName: benefitCarrier.carrierComercialName,
                name: benefitCarrier.carrierName,
                image: benefitCarrier.carrierImage,
                isReference: carrierFound.isReference,
                planClassifications: planClassifications,
                selectedPlans: benefitCarrier.plans.map(plan => {
                  const ageIntervals = plan.ageIntervals;

                  if(plan.enumeratedAges && plan.enumeratedAges.length) {
                    for(let i = 0; i <= 8; i++) {
                      ageIntervals[i].beneficiariesFiftyNinePlus = null;
                    }
                    ageIntervals[ageIntervals.length - 1].beneficiariesFiftyNinePlus = plan.enumeratedAges;
                  }


                  return {
                    id: plan.id,
                    description: plan.description,
                    ageRange: ageIntervals
                  }
                })
              }

              benefit.push({
                id: benefitCarrier.benefitId,
                code: benefitCarrier.benefitCode,
                name: benefitCarrier.benefitName,
                carriers: [carrier]
              });
            }
          })
        }
      }

      let studyConfigurationId = null;
      if(this.quoteDataObj && this.quoteDataObj.projectObj ) {
        studyConfigurationId = this.quoteDataObj.projectObj.id;
      }

      //send others benefits not selecteds to reload in edit option
      if (this.quoteDataObj && this.quoteDataObj.benefitsObj) {
        const benefits = JSON.parse(JSON.stringify(this.quoteDataObj.benefitsObj));
        
        benefits.forEach(benefitItem => {
          benefitItem.carriers.forEach(carrierItem => {
            const benefitFound = benefit.find(item => item.id === benefitItem.id);
            if(benefitFound) {
              const indexOfBenefit = benefit.indexOf(benefitFound);
              if(indexOfBenefit >= 0){
                const carrierFound = benefit[indexOfBenefit].carriers.find(item => item.id === carrierItem.id);
                if(carrierFound) {
                  const indexOfCarrier = benefit[indexOfBenefit].carriers.indexOf(carrierFound);
                  benefit[indexOfBenefit].carriers[indexOfCarrier].planClassifications = carrierItem.planClassifications;
                } else {
                  carrierItem.selectedPlans = [];
                  benefit[indexOfBenefit].carriers.push(JSON.parse(JSON.stringify(carrierItem)));
                }
              }
            } else {
              benefitItem.carriers.forEach(carrier => {
                carrier.selectedPlans = [];
              });

              benefit.push(JSON.parse(JSON.stringify(benefitItem)));
            }
          })
        })

        this.setBenefitsObj(JSON.parse(JSON.stringify(benefits)));
      }
      //end
      
      const id = this.quoteDataObj ? this.quoteDataObj.quoteId : null;
      const parentQuoteId = this.quoteDataObj ? this.quoteDataObj.parentQuoteId : null;

      const payload = {
        id,
        parentQuoteId,
        type,
        lead,
        contractFeatures,
        ageRange,
        benefit,
        studyConfigurationId
      }
      return payload;
    },
    async saveAndSendQuote() {
      this.setDialogLoading(true);
      const payload = this.createQuoteDTO();
      payload.sendQuote = true;

      await this._quoteService.savePolling(payload)
        .then((response) => {
          if(response) {
            this.setQuoteId(response);
            this.showmsg({text: 'A cotação foi enviada com sucesso.', type: 'success'});
          }
        })
        .catch((error) => {
          if(error && error.message) {
             this.showmsg({text: error.message, type: 'error'})
           } else {
             this.showmsg({text: 'Ocorreu um erro ao tentar efetuar o cálculo.', type: 'error'})
           }
        })
        .finally(() => {
          this.setDialogLoading(false);
        });
    },
    async calculateAndDownloadQuote() {
      this.setDialogLoading(true);
      const payload = this.createQuoteDTO();

       await this._quoteService.calculateAndDownloadQuotePolling(payload)
         .then((contentVersion) => {
           //const contentVersion = response && response.data ? response.data : null;
           if(contentVersion && contentVersion.datas) {
             const blobParts = this.$util.base64ToBytesArray(contentVersion.datas);
             const blob = new Blob(blobParts, { type: "application/pdf;base64" })
             const url = window.URL.createObjectURL(blob);
             window.open(url, '_blank', '');
           }else {
             this.showmsg({text: 'Não foi possível gerar o conteúdo do arquivo. (Conteúdo vazio)', type: 'error'})
           }
         })
         .catch((error) => {
           if(error && error.message) {
             this.showmsg({text: error.message, type: 'error'})
           } else {
             this.showmsg({text: 'Ocorreu um erro ao tentar efetuar o cálculo.', type: 'error'})
           }
         })
         .finally(() => {
           this.setDialogLoading(false);
         });
    },
    async calculateAndSaveSessionStorageDataAndRedirect() {
      this.setDialogLoading(true);
      const payload = this.createQuoteDTO();
      
      await this._quoteService.requestKit(payload)
        .then((response) => {
          if(response && response.data && response.data.benefits && response.data.benefits.length) {
            this.setDialogLoading(false);
            this.saveSessionStorageData(response.data.benefits);
          }
        })
        .catch((error) => {
          this.setDialogLoading(false);
          if(error && error.response && error.response.status === 400) {
            this.showmsg({text: error.response.data.message, type: 'error'})
          } else {
            this.showmsg({text: 'Ocorreu um erro ao tentar solicitar o Kit.', type: 'error'})
          }
        });
    },
    saveSessionStorageData(calculatedBenefits) {
      const plans = [];
      calculatedBenefits.forEach(benefit => {
        benefit.carriers.forEach(carrier => {
          carrier.selectedPlans.forEach(plan => {
            plans.push(plan);
          });
        });
      });
      
      this.benefits.forEach(benefit => {
        benefit.carriers.forEach(carrier => {
          carrier.planClassifications.forEach(planClassification => {
            planClassification.plans.forEach(plan => {
              if(plan && plan.id) {
                const planFound = plans.find(planLoaded => parseInt(planLoaded.id) === parseInt(plan.id));
                if(planFound) {
                  plan.totalLives = planFound.totalLives;
                  plan.totalPrice = planFound.totalPrice;
                  plan.copay = planFound.copay;
                  plan.integrator = planFound.integrator;
                }
              }
            });
          });
        });
      });
      
      this.setBenefitsObj(JSON.parse(JSON.stringify(this.benefits)));
      this.setPlansGroupByBenefitCarrierObj(JSON.parse(JSON.stringify(this.plansGroupByBenefitCarrier)));
      sessionStorage.setItem('quoteDataObj', btoa(JSON.stringify(this.quoteDataObj)));
      this.$router.push({name: 'calculate-quote', query: { type: this.selectedJuridicalPerson}});
    },
    filterBenefitCarrierByPlansSelecteds(benefits) {
      return benefits.map(benefit => {
        if(benefit) {
          const carriersFiltered = benefit.carriers.map(carrier => {
            const planClassificationsMaped = carrier.planClassifications.map(planClassification => {
              if(planClassification && planClassification.plans.some(plan => plan.selected)) {
                return {
                  ...planClassification,
                  plans: planClassification.plans.filter(plan => plan.selected)
                }
              } else {
                return null;
              }

            }).filter(planClassification => planClassification)

            if(carrier && planClassificationsMaped.length) {
              return {
                ...carrier,
                planClassifications: planClassificationsMaped,
              }
            } else {
              return null;
            }
          }).filter(carrier => carrier);

          if(carriersFiltered.filter(carrier => carrier).length) {
            return {
              ...benefit,
              carriers: carriersFiltered,
            }
          } else {
            return null;
          }
        }
        return null;

      }).filter(benefit => benefit);
    },
    reloadDataFromSessionStorage(){
      const key = 'quoteDataObj';
      if (sessionStorage.getItem(key)) {
        const quoteData = JSON.parse(atob(sessionStorage.getItem(key)));
        
        this.benefits = quoteData && quoteData.benefitsObj ? Object.assign([], JSON.parse(JSON.stringify(quoteData.benefitsObj))) : [];
        this.updateBenefitsObj();
        
        this.plansGroupByBenefitCarrier = quoteData && quoteData.plansGroupByBenefitCarrierObj ? JSON.parse(JSON.stringify(quoteData.plansGroupByBenefitCarrierObj)) : [];
        this.setPlansGroupByBenefitCarrierObj(JSON.parse(JSON.stringify(this.plansGroupByBenefitCarrier)));

        //load plansTemp
        if(this.plansGroupByBenefitCarrier) {
          this.plansGroupByBenefitCarrier.forEach(benefitCarrier => {
            if(benefitCarrier && benefitCarrier.plans && benefitCarrier.plans.length) {
              benefitCarrier.plans.forEach(plan => {
                this.plansTemp.push(JSON.parse(JSON.stringify(plan)));
              })
            }
          })
        }
      }
      
      this.updateAllAgeIntervals();
    },
    cancelDialog() {
      this.showDialogLifes = !this.showDialogLifes;
    },
    confirmDialog() {
      const hasEmptyItems = this.plansGroupByBenefitCarrier.filter(benefitCarrier => benefitCarrier.plans.filter(plan =>
        plan.enumeratedAges && plan.enumeratedAges.length && plan.enumeratedAges.some(enumerated => !parseInt(enumerated.age))).length);

      const hasValueLessThanFiftyNine = this.plansGroupByBenefitCarrier.filter(benefitCarrier => benefitCarrier.plans.filter(plan =>
        plan.enumeratedAges && plan.enumeratedAges.length && plan.enumeratedAges.some(enumerated => parseInt(enumerated.age) < 59)).length);
      
      if(hasEmptyItems && hasEmptyItems.length) {
        this.msgDialogType = 'EMPTY';
      } else  if(hasValueLessThanFiftyNine && hasValueLessThanFiftyNine.length) {
        this.msgDialogType = 'AGE';
      } else {
        this.msgDialogType = 'INFORMATION';
        this.showDialogLifes = !this.showDialogLifes;
        this.setPlansGroupByBenefitCarrierObj(JSON.parse(JSON.stringify(this.plansGroupByBenefitCarrier)));
        if(this.actionButton === 'REQUEST_KIT') {
          this.calculateAndSaveSessionStorageDataAndRedirect();
        } else if (this.actionButton === 'CALCULATE_QUOTE') {
          this.calculateAndDownloadQuote();
        } else if (this.actionButton === 'SEND_QUOTE') {
          this.saveAndSendQuote();
        }
      }
    },
    async sendInstitutional() {
      if(!this.quoteDataObj || !this.quoteDataObj.projectObj || !this.quoteDataObj.projectObj.id) {
        this.showmsg({text: 'Por favor, selecione um projeto.', type: 'warning'});
        return;
      }

      if(!this.quoteDataObj || !this.quoteDataObj.juridicalPersonObj || !this.quoteDataObj.juridicalPersonObj.emailContact) {
        this.showmsg({text: 'Por favor, informe o e-mail do contato.', type: 'warning'});
        return;
      }
      
      this.setDialogLoading(true);
      if(this.quoteDataObj && this.quoteDataObj.juridicalPersonObj && this.quoteDataObj.projectObj) {
        const params = new URLSearchParams();
        
        if(this.quoteDataObj.juridicalPersonObj.emailWithCopy) {
          params.append('carbonCopy', this.quoteDataObj.juridicalPersonObj.emailWithCopy);
        }

        if(this.quoteDataObj.juridicalPersonObj.emailContact) {
          params.append('to', this.quoteDataObj.juridicalPersonObj.emailContact);
        }
        
        params.append('studyConfigurationId', this.quoteDataObj.projectObj.id);
        
        await this._quoteService.sendInstitutional(params)
          .then(() => {
            this.showmsg({text: 'E-mail enviado com sucesso.', type: 'success'});
          })
          .catch((error) => {
            if(error && error.response && error.response.status === 400) {
              this.showmsg({text: error.response.data.message, type: 'error'})
            } else {
              this.showmsg({text: 'Ocorreu um erro ao tentar enviar institucional.', type: 'error'});
            }
          });
      }
      
      this.setDialogLoading(false);
    }
  },
  beforeCreate() {
    this._quoteService = new QuoteService();
    this._authService = new AuthService();
  },
  async created() {
    this.iReadOnly = this.$route.query.detail && (this.$route.query.detail === true || this.$route.query.detail === 'true');
    this.benefits = JSON.parse(JSON.stringify(this.benefitsObj));
    this.createSelectedAndDisabledAttributesToBenefits();
    this.reloadDataFromSessionStorage();

    let response = await this._authService.findCurrent();
    let authorities = response.data.authorities;
    this.allowSendKit = authorities.filter(
      (a) => (a.authority == 'cotacao_permite_enviar_kit')
    ).length > 0;
  },
};
</script>

<style scoped>
.dashed-bottom {
  border-bottom-color: var(--v-border-base);
  border-bottom-style: dashed;
  border-width: 1px;
}

.dashed-right {
  border-right-color: var(--v-border-base);
  border-right-style: dashed;
  border-width: 1px;
}

.component-col-age {
  height: 45px !important;
}

.component-col-header {
  height: 25px !important;
  color: var(--v-foreground-base);
  font-weight: bold;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
